import styles from './Dock.module.css';
import { useDock } from '../Window/WindowManager';

export function Dock() {
  const { windows, openWindow, restoreWindow } = useDock();

  const minimizedWindows = windows.filter(w => w.state === 'minimized');

  const handleDockClick = (windowId: string, state: string) => {
    if (state === 'minimized') {
      restoreWindow(windowId);
    } else if (state === 'closed') {
      openWindow(windowId);
    } else {
      // Already open, just bring to front (handled by openWindow)
      openWindow(windowId);
    }
  };

  return (
    <div className={styles.dock}>
      <div className={styles.dockMain}>
        {windows.map(window => (
          <button
            key={window.id}
            className={`${styles.dockIcon} ${window.state !== 'closed' ? styles.active : ''}`}
            onClick={() => handleDockClick(window.id, window.state)}
            title={window.title}
          >
            <span className={styles.dockIconEmoji}>{window.icon}</span>
            {window.state !== 'closed' && <span className={styles.dockIndicator} />}
          </button>
        ))}
      </div>
      {minimizedWindows.length > 0 && (
        <>
          <div className={styles.dockDivider} />
          <div className={styles.dockMinimized}>
            {minimizedWindows.map(window => (
              <button
                key={window.id}
                className={styles.dockMinimizedWindow}
                onClick={() => restoreWindow(window.id)}
                title={`Restore ${window.title}`}
              >
                <span className={styles.minimizedIcon}>{window.icon}</span>
                <span className={styles.minimizedTitle}>{window.title}</span>
              </button>
            ))}
          </div>
        </>
      )}
    </div>
  );
}
